import React, { useContext, useEffect, useRef, useState } from "react";
import { Sorting } from "../../../../../components/Lists/Sorting";
import "./PartRequestTabularView.css";
import { PartRequestContext } from "../../../context/PartRequestContext";
import Skeleton from "react-loading-skeleton";
import { ResultsNotFound } from "../../../../../components/ResultsNotFound/ResultsNotFound";
import { useNavigate } from "react-router-dom";
import { CONTEXT_TYPES } from "../../../../../globals/globals";
import { Tag } from "../../../../../components/Tags/Tag";
import { attachContextmenuInfo } from "../../../../../services/contextMenuService";
import { useSnackBar } from "../../../../../hooks/useSnackBar";

import Item from "../../../../../components/Lists/Item";
import { PartRequestTabularInfo } from "./PartRequestTabularInfo/PartRequestTabularInfo";
import { DialogContext } from "../../../../../contexts/DialogContext";
import { GenericPartRequestModal } from "../PartRequestModals/GenericPartRequestModal";
import { DropdownsProvider } from "../../../../../contexts/DropdownsContext";
const icons = {
  success: "icon-success",
  warning: "icon-warning",
  error: "icon-error",
  issued: "icon-issued",
};

const PartImage = ({ item }) => {
  const { successMsg, infoMsg } = useSnackBar();

  const imageActions = {
    image1: {
      label: "Action 1",
      icon: "icon-part",
      callback: () => successMsg("Success"),
    },
    image2: {
      label: "Action 2",
      icon: "icon-settings",
      callback: () => infoMsg("Lorem ipsum"),
    },
  };

  return (
    <div
      className={`image-container ${item.availability}`}
      onContextMenu={(event) =>
        attachContextmenuInfo({
          event,
          type: CONTEXT_TYPES.PART_IMAGE,
          data: "...",
          options: imageActions,
        })
      }
    >
      <i className={icons[item.availability]}></i>
    </div>
  );
};
export const PartRequestTabularView = ({ data }) => {
  //context

  const { openDialog, closeDialog } = useContext(DialogContext);
  const {
    setLoadingPartsReq,
    loadingPartsReq,
    requestNextPage,
    setSortingOrder,
    partRequestList,
    partsRequestToIssue,
    setPartsRequestToIssue,
    page,
    handleTypeRequestSelectionTab,
    typeRequestTab,
    totalPRWorkpackage,
    totalPRTransfer,
  } = useContext(PartRequestContext);

  //ref, states, effects, mapper, variables
  const itemMapper = (item) => {
    if (typeRequestTab == "Workpackage") {
      return {
        id: item.id,
        PRN: item.id || "--",
        WP: item.wp || "--",
        inventoryLocation: item.location || "--",
        Site: item.site_name || "--",
        Aircraft: item.tail_number || "--",
        "Date Required": new Date(item.date_required)
          .toISOString()
          .split("T")[0],
        status: item.status || "Open",
        availability: item.availability,
        companyName: item.company_name || "--",
      };
    } else if (typeRequestTab == "Transfer") {
      return {
        id: item.id,
        PRN: item.id || "--",
        WP: item.wp || "--",
        norigin_location: item.origin_location || "--",
        origin_site: item.origin_site || "--",
        location: item.location || "--",
        Site: item.site_name || "--",
        Aircraft: item.tail_number || "--",
        "Date Required": new Date(item.date_required)
          .toISOString()
          .split("T")[0],
        status: item.status || "Open",
        availability: item.availability,
      };
    }
  };
  let contexthighlightstyle =
    "background-color: var(--blue-500); border: solid 1px var(--green-25);";

  const listRef = useRef(null);
  const didMount = useRef(false);
  const navigate = useNavigate();
  const [formattedItems, setFormattedItems] = useState([]);
  const [openStates, setOpenStates] = useState({});
  const mockOptions = {
    "parts-configuration": {
      label: "Part Issue",
      icon: "icon-issue",
      callback: (part) => {
        navigate("/secure/store/inventory-transaction", {
          state: { data: part, type: "issue" },
        });
      },
    },
  };
  useEffect(() => {
    setFormattedItems(
      partRequestList?.map((item, index) => {
        let mappedItem = itemMapper?.(item) ?? item;
        return { ...mappedItem, id: index };
      }) ?? []
    );
  }, [partRequestList]);

  //functions

  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - (scrollTop + 3) <= clientHeight) {
      if (!loadingPartsReq) {
        requestNextPage();
      }
    }
  };

  const getSortingOrder = (order) => {
    if (!didMount.current) {
      didMount.current = true; // Evita la primera ejecución
      return;
    }
    setSortingOrder(order);
  };

  const closeAllOpenStates = () => {
    setOpenStates((prevState) => {
      const newState = {};
      Object.keys(prevState).forEach((key) => {
        newState[key] = false;
      });
      return newState;
    });
  };

  const toggleOpenState = (partRequestId, itemInfo, e) => {
    e.stopPropagation();
    const hasSelectedParts = partsRequestToIssue?.length > 0;
    const isDifferentRequest =
      hasSelectedParts &&
      itemInfo.PRN !== partsRequestToIssue[0].part_request_id;

    if (isDifferentRequest) {
      openDialog({
        component: GenericPartRequestModal,
        props: {
          title: "Warning",
          description: `You have parts selected in the current Part Request (<strong>PRN-${partsRequestToIssue[0].part_request_id}</strong>).<br/>Open a new one anyway? This will cancel your current selection.`,
          close: closeDialog,
          okAction: () => openAndCloseItemFromDialog(partRequestId),
        },
      });
    } else {
      closeAllOpenStates();
      setTimeout(() => {
        setOpenStates((prevState) => ({
          ...prevState,
          [partRequestId]: !openStates[partRequestId],
        }));
      }, 100);
    }
  };
  const openAndCloseItemFromDialog = (partRequestId) => {
    setPartsRequestToIssue([]);
    closeDialog();
    closeAllOpenStates();
    setTimeout(() => {
      setOpenStates((prevState) => ({
        ...prevState,
        [partRequestId]: !openStates[partRequestId],
      }));
    }, 100);
  };
  const [sortingColumns, setSortingColumns] = useState({});

  useEffect(() => {
    if (typeRequestTab == "Workpackage") {
      const data = {
        prn: "PRN",
        wp: "WP",
        location: "Location",
        site: "Site",
        aircraft: "Aircraft",
        date: "Date Required",
        company_name: "Company",
        // status: "Status",
      };

      setSortingColumns(data);
    } else if (typeRequestTab == "Transfer") {
      const data = {
        prn: "PRN",
        wp: "WP",
        origin_location: "Origin Location",
        origin_site: "Origin Site",
        location: "Destination Location",
        site: "Destination Site",
        aircraft: "Aircraft",
        date: "Date Required",
      };

      setSortingColumns(data);
    }
  }, [typeRequestTab]);
  return (
    <>
      <section className="button-tabs-prn-tabular">
        <button
          onClick={() => {
            handleTypeRequestSelectionTab("Workpackage");
          }}
          style={{
            background:
              typeRequestTab == "Workpackage" ? "var(--black-mid)" : "#FBFBFB",
            color:
              typeRequestTab == "Workpackage"
                ? "var(--white)"
                : "var(--black-mid)",
          }}
        >
          <p>Work Package</p>
          <span>{totalPRWorkpackage}</span>
        </button>
        <button
          onClick={() => {
            handleTypeRequestSelectionTab("Transfer");
          }}
          style={{
            background:
              typeRequestTab == "Transfer" ? "var(--black-mid)" : "#FBFBFB",
            color:
              typeRequestTab == "Transfer"
                ? "var(--white)"
                : "var(--black-mid)",
          }}
        >
          <p>Transfer</p>
          <span>{totalPRTransfer}</span>
        </button>
      </section>
      <div
        className={`part-request-tabular-list-header ${
          typeRequestTab === "Workpackage"
            ? "wp"
            : typeRequestTab === "Transfer"
            ? "Transfer"
            : ""
        }`}
      >
        <div className="sorting-free-slot"> </div>
        <Sorting
          onOrderChange={getSortingOrder}
          ignoreProperties={true}
          showHeaderOrder={true}
          properties={sortingColumns}
        ></Sorting>
      </div>
      <div
        className="part-request-tabular-list"
        ref={listRef}
        onScroll={handleScroll}
      >
        {loadingPartsReq && page === 0 ? (
          // Mostrar esqueletos mientras carga
          Array.from({ length: 7 }).map((_, idx) => (
            <div key={idx} className="item-container-skeleton">
              <Skeleton
                style={{ borderRadius: "10px" }}
                height="1.68rem"
                width={40}
              />
              <div className="item-skeleton-content">
                <Skeleton height={20} width="80%" />
              </div>
              <Skeleton height={30} width="7rem" />
            </div>
          ))
        ) : formattedItems.length === 0 ? (
          <ResultsNotFound />
        ) : (
          formattedItems.map((item, idx) => (
            <React.Fragment key={`${item.id}-${idx}`}>
              <div
                className={`${openStates[item.id] ? "active-class-part" : ""}`}
              >
                <Item
                  onClick={(e) => toggleOpenState(item.id, item, e)}
                  contextMenuInfo={{
                    type: CONTEXT_TYPES.PART,
                    options: mockOptions,
                    highlightstyle: contexthighlightstyle,
                  }}
                  hideLabels={true}
                  lightFont={true}
                  item={item}
                  itemPrefix={PartImage}
                  itemSuffix={({ item }) => (
                    <Tag
                      style={{ width: "9vw" }}
                      tag={item.status}
                      type={item.status == "Posted" ? "success" : "info"}
                    ></Tag>
                  )}
                  ignoreProperties={["id", "status", "availability"]}
                />
              </div>
              {openStates[item.id] && (
                <DropdownsProvider>
                  <PartRequestTabularInfo
                    item={item}
                    open={openStates[item.id]}
                  ></PartRequestTabularInfo>
                </DropdownsProvider>
              )}
            </React.Fragment>
          ))
        )}
      </div>
    </>
  );
};
